import React, {Component} from 'react';
// material
import SubPage from 'material/structure/subpage/subpage';
import EditUser from 'pages/dashboard/account/users/edituser/edituser_container';
import AddUser from 'pages/dashboard/account/users/adduser/adduser_container';
import DeleteUser from 'pages/dashboard/account/users/deleteuser/deleteuser_container';
import Group from 'material/group/group';
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
import Link from 'material/ctas/link/link_container';
import Icon from 'material/graphic/icon/icon';
import Table from 'material/table/table';
//styles
// import injectSheet from 'react-jss';
// import styles from 'pages/dashboard/account/users/users_styles';

//[{"userUUID":"6ad7d870-f91e-4f2f-a3cc-6d2cb9728fe9","firstName":"Vlad","lastName":"Deev","email":"vlad@aefaefa.com","phoneNumber":"(212) 225-2213","userStatus":"INVITE_SENT","permissions":["settings.paymentInfo","settings.general","settings.adsTxt","manageEmbeds"]},{"userUUID":"173ad632-88bc-4b73-b775-3f5305c2a9f3","firstName":"Jonathan","lastName":"Aquino","email":"jonathanaquino@insticator.com","phoneNumber":"(646) 204-3782","userStatus":"ACTIVATED","permissions":["setttings.sites","settings.paymentInfo","settings.users","settings.agreement","settings.general","settings.adsTxt","manageEmbeds"]},{"userUUID":"ca95fa53-d8fa-4c30-a4db-13120436b5f7","firstName":"George","lastName":"Jefferson","email":"bigJeff@gmail.com","phoneNumber":"(212) 225-2213","userStatus":"INVITE_SENT","permissions":["settings.paymentInfo","settings.general","settings.adsTxt","manageEmbeds"]}]



/* ========== ~~~~~~~~~~ PAGE : USERS : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Users extends Component {
    componentDidMount(){
        this.props.getUsers(this.props.accountUUID)
    }
    handleTableData = () => {
        let dataArray = [];
        this.props.users.map((item, index) => {
            let disable = item.userUUID === this.props.userUUID;
            return dataArray.push({
                name: item.firstName, email: <Link type={`email`} text={item.email} color={`primary`} action={`mailto:${item.email}`} />,
                edit: (
                    <div className={`editcolumn`} >
                        {item.userStatus === 'INVITE_SENT' && <Link type={'action'} text={'Resend Invite'} operation={'send'} processing={this.props.resendingInvite.includes(item.userUUID)} color={'primary'} removeLoaderIcon={true} action={()=>this.props.resendInvite(item.userUUID)} icon={<Icon name={`envelope`} />} />}
                        <Link type={`modal`} disabled={disable} text={`Edit`} color={`primary`} icon={<Icon name={`pencil-alt`}/>} action={<EditUser index={index} userInfo={item}/>} />
                        <Link type={`modal`} text={`Delete`} disabled={disable} color={`primary`} icon={<Icon name={`trash-alt`}/>} action={<DeleteUser email={item.email} index={index} userUUID={item.userUUID} name={`${item.firstName} ${item.lastName}`}/>} />
                    </div>),
                status: item.userStatus.split('_').join(' ') })
        });
        return dataArray;
    };
    render() {
        return(
            <SubPage name={`users`}>
                <Copy name={`page-copy`}>
                    <Title variant={'withctas'}>
                        <h2>Users</h2>
                        <Group name={`controls`}>
                            <CTAs>
                                <Button type={'modal'} action={<AddUser/>} variant={`primary`} name={`add_user`} text={`Add User`} />
                            </CTAs>
                        </Group>
                    </Title>
                </Copy>
                <Group name={`page-details`}>
                    <Table 
                        name={`users`}
                        type={`fixed-column`}
                        fixedColWidth={150}
                        size={`full`}
                        columnHeads={{ name: 'Name', email: 'Email', status: 'Status', edit: '' }}
                        data={this.handleTableData()}
                        rowsPerPage={'general'}
                        paginationLocation={`bottom`}
                    />
                </Group>
            </SubPage>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default Users;
// export default injectSheet(styles)(Users);